/**
 * Agent photo upload specs.
 * Photos are center-cropped to a square and saved at 1000×1000 px.
 */
export const AGENT_PHOTO_UPLOAD = {
  width: 1000,
  height: 1000,
  aspectRatio: '1:1',
  formats: ['JPG', 'PNG', 'WebP'],
  maxFileSizeMb: 2,
  instructions: [
    'Any portrait or landscape photo is accepted',
    'Automatically center-cropped to a square',
    'Saved at 1000 × 1000 pixels (JPEG)',
    'Keep the face centered in the original photo',
  ],
};

export const AGENT_PHOTO_DISPLAY = {
  card: { width: 500, height: 500, cssHeight: 250 },
  profile: { width: 200, height: 200, renderWidth: 400, renderHeight: 400 },
};
